import React from "react";
import Header from "./Header/Header";
import Nav from "./Nav/Nav";
import About from "./About/About";
import Contact from "./Contact/Contact";
import Footer from "./Footer/Footer";
import Experience from "./Experience/Experience";

function Home() {
  return (
    <div>
      <Header />
      <Nav />
      <About />
      <Experience />
      <Contact />
      <Footer />
    </div>
  );
}

export default Home;
